export function getFlipsterEarnBufferCardRow(input: {
  isLoggedIn: boolean;
  hasFirstDeposit: boolean;
  isMintAvailable: boolean;
}): 1 | 2 | 3 {
  if (!input.isLoggedIn) return 1;
  if (input.isMintAvailable || input.hasFirstDeposit) return 2;
  return 3;
}
